import React from "react";
import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { routes } from "./routes";
import { useSelector } from "react-redux";

function RecruiterCheckRole() {
  const token = JSON.parse(localStorage.getItem("token"));
  const userType = JSON.parse(localStorage.getItem("user"));
  const auth = useSelector((state) => state.auth);

  let user = false;
  if (userType === "recruitment") {
    user = true;
  }
  return user ? <Outlet /> : <Navigate to={routes.LOGIN} replace />;
}

export default RecruiterCheckRole;
